import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then(r => setStats(r.data)); }, []);

  return (
    <div className="max-w-6xl mx-auto px-5 lg:px-8 py-10">
      <h1 className="font-display text-3xl font-semibold text-[var(--fpn-navy)]" data-testid="admin-dashboard-title">Admin dashboard</h1>
      <p className="text-sm text-slate-600 mt-1">Operational overview.</p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
        <Stat testId="admin-stat-searches" label="Searches today" value={stats?.searches_today ?? 0}/>
        <Stat testId="admin-stat-bookings" label="Bookings today" value={stats?.bookings_today ?? 0}/>
        <Stat testId="admin-stat-gbv" label="Gross booking value" value={`£${(stats?.gross_booking_value ?? 0).toFixed(2)}`}/>
        <Stat testId="admin-stat-revenue" label="Platform revenue" value={`£${(stats?.platform_revenue ?? 0).toFixed(2)}`}/>
        <Stat testId="admin-stat-customers" label="Active customers" value={stats?.active_customers ?? 0}/>
        <Stat testId="admin-stat-hosts" label="Active hosts" value={stats?.active_hosts ?? 0}/>
        <Stat testId="admin-stat-approved" label="Approved spaces" value={stats?.approved_spaces ?? 0}/>
        <Stat testId="admin-stat-pending" label="Pending approvals" value={stats?.pending_approvals ?? 0} highlight/>
      </div>

      <div className="mt-10 grid md:grid-cols-3 gap-4">
        <Link to="/admin/community-listings" className="border border-slate-200 rounded-2xl p-6 bg-white card-lift" data-testid="admin-nav-listings">
          <div className="font-display text-lg font-semibold text-[var(--fpn-navy)]">Community Listings</div>
          <div className="text-sm text-slate-500 mt-1">Review and approve host listings</div>
        </Link>
        <div className="border border-slate-200 rounded-2xl p-6 bg-white opacity-60">
          <div className="font-display text-lg font-semibold text-[var(--fpn-navy)]">API Health</div>
          <div className="text-sm text-slate-500 mt-1">Coming next milestone</div>
        </div>
        <div className="border border-slate-200 rounded-2xl p-6 bg-white opacity-60">
          <div className="font-display text-lg font-semibold text-[var(--fpn-navy)]">Payments & Payouts</div>
          <div className="text-sm text-slate-500 mt-1">Coming next milestone</div>
        </div>
      </div>

      <div className="mt-6 grid md:grid-cols-3 gap-4">
        <Link to="/admin/hosts" className="border border-slate-200 rounded-2xl p-6 bg-white card-lift" data-testid="admin-nav-hosts">
          <div className="font-display text-lg font-semibold text-[var(--fpn-navy)]">Hosts</div>
          <div className="text-sm text-slate-500 mt-1">Manage hosts + Stripe Connect test toggle</div>
        </Link>
      </div>
    </div>
  );
}

const Stat = ({ label, value, highlight, testId }) => (
  <div data-testid={testId} className={`border rounded-2xl p-5 bg-white ${highlight ? "border-[var(--fpn-amber)]" : "border-slate-200"}`}>
    <div className="text-xs text-slate-500 uppercase tracking-widest">{label}</div>
    <div className="font-display text-3xl font-bold text-[var(--fpn-navy)] mt-2">{value}</div>
  </div>
);
